/* eslint-disable max-len */
import React from "react";
import { object, func, number, bool } from "prop-types";
import { LoadMoreStoriesBase } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import { NotFoundPage } from "../not-found";
import Stories2AdWithLoadMore from "../../rows/Stories2AdWithLoadMore";
import HeaderWrapper from "../../header/header-wrapper";
import { staticTexts } from "../../utils/Translate";

import "./tag.m.css";

const NO_OF_STORIES_TO_LOAD = 6;

function TagPageBase({ data, publisherAttributes }) {
  const { tag } = data;

  if (!tag) {
    return <NotFoundPage />;
  }

  const imgRegex = new RegExp("<img[^>]*?>", "g");
  const tagDescription = tag.description ? tag.description.replace(tag.description.match(imgRegex), "") : "";
  const storyFields =
    "headline,subheadline,author-name,author-id,authors,last-published-at,hero-image-metadata,hero-image-s3-key,slug,id,story-template,tags,url,cards,alternative,metadata";

  return (
    <React.Fragment>
      <HeaderWrapper />
      <div>
        <div styleName="content">
          <Headline
            text={staticTexts(publisherAttributes.lang).tag}
            headerLevel={3}
            headlineType={27}
            className="name"
          />
          {tag ? (
            <React.Fragment>
              <Headline text={tag.name} headerLevel={1} headlineType={38} className="title" />
              {tagDescription ? (
                <span className="sub-title" dangerouslySetInnerHTML={{ __html: tagDescription }}></span>
              ) : null}
            </React.Fragment>
          ) : null}
        </div>
        <div>
          {data.stories.length ? (
            <LoadMoreStoriesBase
              template={MoreCollectionStories}
              fields={storyFields}
              params={{ "tag-slugs": tag.slug }}
              data={data}
              numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
            />
          ) : (
            <div styleName={`no-stories ${publisherAttributes.lang === "en" ? "en-no-stories" : ""}`}>
              No stories found !!
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

function MoreCollectionStories({ stories, onLoadMore, noMoreStories, loading }) {
  return (
    <Stories2AdWithLoadMore
      list={stories}
      loading={loading}
      onLoadMore={onLoadMore}
      isMoreStories={NO_OF_STORIES_TO_LOAD <= stories.length && !noMoreStories}
    />
  );
}

TagPageBase.propTypes = {
  data: object,
  config: object,
  publisherAttributes: object
};

MoreCollectionStories.propTypes = {
  stories: object,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

const TagPage = connect(mapStateToProps, null)(TagPageBase);

export { TagPage };
